<template>
    <div class="container-fluid">
        <div class="m-2">
            <div class="alert alert-primary">
                <div class="h4 text-center">
                    <linkto :link="'/'"/>
                    Új ügyfél rögzítés
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
  		      <div class="col-6 text-center h4">
                Rögzítette: {{$store.getters.user.nev}}
            </div>
            <div class="col-6 text-center h4">
                Rögzítve: {{datum}}
            </div>
  			</div>
  			<div class="row d-flex justify-content-center align-items-center">
  				  <customerdata
                :change="false"
                :user="$store.getters.user.nev"
  				  >
  				  </customerdata>
  			</div>
  	</div>
</template>

<script>
import customerdata from './customer_data'
export default {
    name: 'new_customer',
    
    components: {
        customerdata
    },
  
    computed: {
        datum(){
		        return this.$moment().format('YYYY-MM-DD')
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/customers/new_customer.vue